// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Next = require("../../../reason/next/Next.bs.js");
let React = require("react");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let MlsStatusQuery = require("../propertyForms/Geocoding/MlsStatusQuery.bs.js");
let WizardGeocoding = require("../wizard/WizardGeocoding.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let WizardDraftIdSync = require("../wizard/WizardDraftIdSync.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let PropertyWizardQueryParams = require("./PropertyWizardQueryParams.bs.js");
let PropertyWizardFormRelayEffects_formState_graphql = require("../../../__generated__/PropertyWizardFormRelayEffects_formState_graphql.bs.js");
let PropertyWizardFormRelayEffects_localDraft_graphql = require("../../../__generated__/PropertyWizardFormRelayEffects_localDraft_graphql.bs.js");

let convertFragment = PropertyWizardFormRelayEffects_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, fRef);
}

let LocalDraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelayEffects_localDraft_graphql.Utils.localDraftPropertyType_decode;

let LocalDraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelayEffects_localDraft_graphql.Utils.localDraftPropertyType_fromString;

let LocalDraftFragment = {
  localDraftPropertyType_decode: LocalDraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: LocalDraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardFormRelayEffects_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftMlsStatus_decode = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftMlsStatus_decode;

let FormStateFragment_localDraftMlsStatus_fromString = PropertyWizardFormRelayEffects_formState_graphql.Utils.localDraftMlsStatus_fromString;

let FormStateFragment_localGeocodingStatus_decode = PropertyWizardFormRelayEffects_formState_graphql.Utils.localGeocodingStatus_decode;

let FormStateFragment_localGeocodingStatus_fromString = PropertyWizardFormRelayEffects_formState_graphql.Utils.localGeocodingStatus_fromString;

let FormStateFragment = {
  localDraftMlsStatus_decode: FormStateFragment_localDraftMlsStatus_decode,
  localDraftMlsStatus_fromString: FormStateFragment_localDraftMlsStatus_fromString,
  localGeocodingStatus_decode: FormStateFragment_localGeocodingStatus_decode,
  localGeocodingStatus_fromString: FormStateFragment_localGeocodingStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function use$2(draft, formState, setDuplicatedProperty) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let match$1 = PropertyWizardQueryParams.use();
  let setQueryParams = match$1[1];
  let mlsStatusTriggeredAt = React.useRef(Date.now());
  let doMlsStatusCheck = PropertyWizardRelayUtils.useMlsStatusCheck();
  let draft$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_localDraft_graphql.node, convertFragment, draft);
  let formState$1 = RescriptRelay_Fragment.useFragment(PropertyWizardFormRelayEffects_formState_graphql.node, convertFragment$1, formState);
  let updateFormState = PropertyWizardFormRelay.FormState.useUpdater();
  let updateDraftProperty = PropertyWizardFormRelay.useUpdateDraftProperty();
  let selectedAreaId = Stdlib_Option.map(draft$1.draftProperty.selectedArea, area => area.id);
  let match$2 = draft$1.draftProperty.propertyType;
  let tmp;
  tmp = match$2 === "FOR_SALE" ? "SELLER" : "LANDLORD";
  let tmp$1;
  if (typeof mode !== "object") {
    tmp$1 = undefined;
  } else {
    switch (mode.TAG) {
      case "Edit" :
        tmp$1 = mode.id;
        break;
      case "Rebroadcast" :
      case "BroadcastQuietSeller" :
        tmp$1 = mode._0;
        break;
    }
  }
  WizardGeocoding.use(formState$1.geocodingStatus, selectedAreaId, draft$1.draftProperty.addressToGeocode, tmp, tmp$1, setDuplicatedProperty, geocodingData => updateDraftProperty(localDraftProperty => {
    let newrecord = {...localDraftProperty};
    newrecord.geocodingData = geocodingData;
    return newrecord;
  }), displayNeighborhoods => updateFormState(formState => PropertyWizardFormRelay.FormState.setDisplayNeighborhoods(formState, displayNeighborhoods.map(dn => ({
    __id: dn.__id,
    __typename: dn.__typename
  })))), geocodingStatus => updateFormState(formState => {
    formState.geocodingStatus = geocodingStatus;
  }));
  React.useEffect(() => {
    if (doMlsStatusCheck) {
      let run = async () => {
        let match = formState$1.mlsStatus;
        let match$1 = draft$1.draftProperty.addressToGeocode;
        if (match === "Called") {
          return;
        }
        if (selectedAreaId === undefined) {
          return;
        }
        if (match$1 === undefined) {
          return;
        }
        if (match$1.trim() === "") {
          return;
        }
        let triggeredAt = Date.now();
        mlsStatusTriggeredAt.current = triggeredAt;
        updateFormState(formState => {
          formState.mlsStatus = "Called";
        });
        let res = await MlsStatusQuery.queryFn(match$1, selectedAreaId);
        if (triggeredAt !== mlsStatusTriggeredAt.current) {
          return;
        }
        if (res.TAG !== "Ok") {
          return updateFormState(formState => {
            formState.mlsStatus = "Error";
          });
        }
        let mlsStatus;
        switch (res._0.__typename) {
          case "PropertyMlsStatusNotOnMls" :
            mlsStatus = "NotOnMls";
            break;
          case "PropertyMlsStatusOnMls" :
            mlsStatus = "OnMls";
            break;
          case "PropertyMlsStatusOnMlsButAllowed" :
            mlsStatus = "OnMlsButAllowed";
            break;
          case "__unselected" :
            mlsStatus = "Error";
            break;
        }
        return updateFormState(formState => {
          formState.mlsStatus = mlsStatus;
        });
      };
      run();
    } else {
      updateFormState(formState => {
        formState.mlsStatus = "NotOnMls";
      });
    }
  }, [
    draft$1.draftProperty.addressToGeocode,
    selectedAreaId,
    mode,
    draft$1.draftProperty.propertyType,
    doMlsStatusCheck
  ]);
  WizardDraftIdSync.use(match$1[0].draftId, draft$1.serverDraftId, draftId => setQueryParams("replaceIn", {
    draftId: draftId
  }));
  let router = Next.useRouter();
  React.useEffect(() => {
    Next.Router.prefetch("/my_clients/[id]", router);
  }, []);
}

let QueryParams;

let Form;

let Validators;

let KeyFactsValidators;

exports.QueryParams = QueryParams;
exports.Form = Form;
exports.LocalDraftFragment = LocalDraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.Validators = Validators;
exports.KeyFactsValidators = KeyFactsValidators;
exports.use = use$2;
/* Next Not a pure module */
